export enum Constant {
  Version = '20260801.1',
  AndroidVersion = '20260712.1',
  AndroidApkUrl = 'https://workdrive.zoho.in/file/wj6ub751fcea799c84ac6bc09f8ed2f1510b0',
  ComputerBackgroudFilesVersion = '20260730.1',
  ComputerBackgroudFilesUrl = 'https://workdrive.zoho.in/folder/2nzi819fcda1eabf443339956aac877f44b00',
}
